import { useState } from "react";
import Sidebar from "./Sidebar";
import { Menu } from "lucide-react";

export default function AppLayout({ children, title, subtitle, actions }) {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar mobileOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      {menuOpen && (
        <div className="fixed inset-0 z-30 bg-slate-900/50 lg:hidden" onClick={() => setMenuOpen(false)}
             data-testid="sidebar-backdrop" />
      )}
      <main className="lg:pl-64 min-h-screen">
        <header className="sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-slate-200">
          <div className="px-4 sm:px-8 py-4 sm:py-5 flex flex-wrap items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <button className="lg:hidden p-2 -ml-2 rounded-md hover:bg-slate-100" onClick={() => setMenuOpen(true)}
                      data-testid="mobile-menu-button" aria-label="Menü">
                <Menu className="h-5 w-5 text-slate-700" />
              </button>
              <div className="min-w-0">
                <h1 className="font-display text-xl sm:text-2xl font-semibold text-slate-900 tracking-tight"
                    data-testid="page-title">
                  {title}
                </h1>
                {subtitle && <p className="text-xs sm:text-sm text-slate-500 mt-0.5">{subtitle}</p>}
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">{actions}</div>
          </div>
        </header>
        <div className="p-4 sm:p-8 animate-in">{children}</div>
      </main>
    </div>
  );
}
